var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMagnifyingGlassIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.148 15.383-3.486-3.516c.82-1.21 1.143-2.627.967-4.248-.215-1.367-.8-2.52-1.758-3.457q-1.4355-1.4355-3.486-1.728c-1.348-.157-2.569.058-3.662.644a6.51 6.51 0 0 0-2.52 2.52c-.586 1.093-.8 2.314-.644 3.662.195 1.367.771 2.53 1.728 3.486.938.977 2.09 1.563 3.457 1.758 1.621.176 3.037-.147 4.248-.967l3.516 3.486c.234.235.508.352.82.352.313 0 .586-.117.82-.352.235-.234.352-.507.352-.82 0-.312-.117-.586-.352-.82M4.814 8.469c.02-1.055.391-1.934 1.114-2.637C6.63 5.11 7.51 4.738 8.564 4.72c1.055.02 1.944.39 2.666 1.113.704.703 1.065 1.582 1.085 2.637-.02 1.054-.381 1.933-1.085 2.636-.722.723-1.61 1.094-2.666 1.114-1.054-.02-1.933-.39-2.636-1.114-.723-.703-1.094-1.582-1.114-2.636Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMagnifyingGlassIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/magnifying-glass-icon.644a4c64c8f7d2b2b7cd366b93d4bff5.svg";